module.exports = __webpack_public_path__ + "img/avatar6.dca87159.jpg";